export const enum Timeouts {
  OneSecond = 1000,
  ThreeSeconds = 3000,
  FiveSeconds = 5000,
  TenSeconds = 10000,
  FifteenSeconds = 15000,
}
